// extracted by mini-css-extract-plugin
export default {"page":"iT","headerwrap":"jT","headerblock":"kT","textwrapper":"lT","text":"mT","closerlook":"nT","arrowwrap":"oT","icon":"pT","updown":"qT","products":"rT","system":"sT","systemimage":"tT","cards":"uT","note":"vT","fadein":"wT"};
    if(module.hot) {
      // 1715632478719
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  